import React from 'react';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import styles from './EditModeActionBar.module.css';

interface EditModeActionBarProps {
  selectedCount: number;
  onDelete: () => void;
  onCancel: () => void;
}

const EditModeActionBar: React.FC<EditModeActionBarProps> = ({
  selectedCount,
  onDelete,
  onCancel,
}) => {
  return (
    <div className={styles.actionBar}>
      <div className={styles.selectionInfo}>
        {selectedCount} message{selectedCount !== 1 ? 's' : ''} selected
      </div>
      <div className={styles.actions}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          startIcon={<CloseIcon />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onDelete}
          startIcon={<DeleteIcon />}
          disabled={selectedCount === 0}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default EditModeActionBar;
